<ion-card mode="ios" class="subordinate-profile" *ngIf="user?.name || user?.username">
  <ion-item lines="none" mode="ios" class="employee-identification">
    <ion-avatar slot="start">
      <img [src]="getImageUrl(user?.imageUrl)" alt="" default="">
    </ion-avatar>
    <div class="employee-data">
      <ion-label>
        <h2>{{ user?.name || user?.username }}</h2>
      </ion-label>
      <div class="employee-attributes" *ngIf="user?.group || user?.rank">
        <ion-label *ngIf="user?.group" class="attribute-value">{{ user?.group }}</ion-label>
        <ion-label *ngIf="user?.rank" class="attribute-value">{{ user?.rank }}</ion-label>
      </div>
    </div>
  </ion-item>
</ion-card>